"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchAnyPattern = exports.extractTerms = exports.repeatedTimeunitPattern = void 0;

function repeatedTimeunitPattern(prefix, singleTimeunitPattern) {
  var singleTimeunitPatternNoCapture = singleTimeunitPattern.replace(/\((?!\?)/g, "(?:");
  return "".concat(prefix).concat(singleTimeunitPatternNoCapture, "\\s{0,5}(?:,?\\s{0,5}").concat(singleTimeunitPatternNoCapture, "){0,10}");
}

exports.repeatedTimeunitPattern = repeatedTimeunitPattern;

function extractTerms(dictionary) {
  var keys;

  if (dictionary instanceof Array) {
    keys = _toConsumableArray(dictionary);
  } else if (dictionary instanceof Map) {
    keys = Array.from(dictionary.keys());
  } else {
    keys = Object.keys(dictionary);
  }

  return keys;
}

exports.extractTerms = extractTerms;

function matchAnyPattern(dictionary) {
  var joinedTerms = extractTerms(dictionary).sort(function (a, b) {
    return b.length - a.length;
  }).join("|").replace(/\./g, "\\.");
  return "(?:".concat(joinedTerms, ")");
}

exports.matchAnyPattern = matchAnyPattern;